// extracted by mini-css-extract-plugin
export default {"footer":"footer_CldoP","title":"title_G5gYL","info":"info_bm6lA"};